<template>
  <v-list nav dense>
    <!-- Ítems raíz -->
    <v-list-item
      to="/Profile"
      exact
      exact-active-class="v-list-item--active blue--text text--accent-4"
    >
      <v-list-item-icon><v-icon>mdi-account-circle</v-icon></v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t("nav.Profile") }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      v-if="persona.Rol == 1"
      :to="{ name: 'Persona' }"
      router
      exact
      exact-active-class="v-list-item--active blue--text text--accent-4"
    >
      <v-list-item-icon><v-icon>mdi-account-multiple</v-icon></v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t("nav.Persona") }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      v-if="persona.Rol == 1"
      :to="{ name: 'Rol' }"
      router
      exact
      exact-active-class="v-list-item--active blue--text text--accent-4"
    >
      <v-list-item-icon><v-icon>mdi-key</v-icon></v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t("nav.Rol") }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <!-- Grupo: Malla 2018-2022 -->
    <v-list-group
      :value="
        isActive([
          'Presentacion18',
          'CapituloUno18',
          'CapituloDos18',
          'CapituloTres18',
          'CapituloCuatro18',
          'CapituloCinco18',
          'CapituloSeis18',
          'Anexos18',
        ])
      "
    >
      <template v-slot:activator>
        <v-list-item>
          <v-list-item-icon><v-icon>mdi-book-open</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("Malla 2018-2022") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list-item
        :to="{ name: 'Presentacion18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Presentacion")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloUno18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo I: Referentes Organizacionales")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloDos18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo II: Fundamentos Curriculares")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloTres18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo III: Perfil Profesional")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloCuatro18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo IV: Estructura Curricular")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloCinco18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo V: Planes de Asignaturas por Competencias")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloSeis18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo VI: Sistema de Evaluación")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'Anexos18' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Anexos")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <!-- Grupo: Malla 2024-2028 -->
    <v-list-group
      :value="
        isActive([
          'Presentacion',
          'CapituloUno',
          'CapituloDos',
          'CapituloTres',
          'CapituloCuatro',
          'CapituloCinco',
          'CapituloSeis',
          'CapituloSiete',
          'CapituloOcho',
          'CapituloNueve',
          'CapituloDiez',
          'CapituloOnce',
          'CapituloDoce',
          'CapituloTrece',
          'Anexos',
          'Validacion',
          'Imprimir',
        ])
      "
    >
      <template v-slot:activator>
        <v-list-item>
          <v-list-item-icon><v-icon>mdi-book-open</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("Malla 2024-2028") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list-item
        :to="{ name: 'Presentacion' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Presentación")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloUno' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo I: Referentes Organizacionales")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloDos' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo II: Referentes Institucionales")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloTres' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo III: Referentes Profesionales/Laborales")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloCuatro' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo IV: Referentes Disciplinarios o Científicos")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloCinco' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo V: Fundamentos Curriculares")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloSeis' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo VI: Perfil Profesional")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloSiete' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo VII: Estructura Curricular Profesional")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloOcho' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo VIII: Políticas de Admisión y Graduación")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloNueve' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo IX: Investigación")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloDiez' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo X: Interacción Social y Extensión Universitaria")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloOnce' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo XI: Implementación del Proyecto Curricular")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloDoce' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo XII: Evaluación Curricular")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'CapituloTrece' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Capítulo XIII: Reglamentos")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'Anexos' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Anexos")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="persona.Rol == 1 || persona.Rol == 4"
        :to="{ name: 'Validacion' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-check-circle</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Validacion") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="persona.Rol == 1 || persona.Rol == 4"
        :to="{ name: 'Imprimir' }"
        router
        exact
        exact-active-class="v-list-item--active blue--text text--accent-4"
      >
        <v-list-item-icon><v-icon>mdi-file</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :style="{ whiteSpace: 'normal' }">{{
            $t("Imprimir Documento")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  name: "MenuVuetify",
  data() {
    return {
      msg: "MenuVuetify",
      persona: {},
    };
  },
  mounted() {
    const persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Login");
      return;
    }
    this.persona = persona;
    if (typeof this.getUnidadAcademica === "function") {
      this.getUnidadAcademica();
    }
  },
  methods: {
    isActive(routeNames) {
      return routeNames.includes(this.$route.name);
    },
  },
};
</script>
